import { render, staticRenderFns } from "./InternalProcessLayout.vue?vue&type=template&id=4aba5bea&scoped=true&"
import script from "./InternalProcessLayout.vue?vue&type=script&lang=js&"
export * from "./InternalProcessLayout.vue?vue&type=script&lang=js&"
import style0 from "./InternalProcessLayout.vue?vue&type=style&index=0&id=4aba5bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aba5bea",
  null
  
)

export default component.exports